/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Segment_Start_LabelInputs */



/**
* | output |
* | --- |
* | "Start" |
*
* @param {Video_Export_Segment_Start_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_segment_start_label = /** @type {((inputs?: Video_Export_Segment_Start_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Segment_Start_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Commencer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Start")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inizio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начинать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comenzar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始")
	if (locale === "ja") return /** @type {LocalizedString} */ ("始める")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शुरू")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Começar")
	return /** @type {LocalizedString} */ ("Start")
});